export default __webpack_public_path__ + "static/media/Hyrkanian Twilight Void Racer.4f86ff6a.jpg";